<div class="btn" [ngClass]="{ 'download-center-route-style': this.currentUrl === '/next/download-center' }"
     data-toggle="tooltip" title="{{phoenixCommonModuleResourceKeys.generic.downloads | phxTranslate}}"
     (click)="gotToDownloadCenter()">
    <div class="color-bar"></div>
    <div *ngIf="showRedDot" class="red-dot"></div>
    <i class="material-icons">get_app</i>
</div>
